import { AxiosInstance } from 'axios'

import { PaginateDTO } from '@shared/dto/PaginateDTO'

import {
  EmployeePerson,
  EmployeePersonFull,
  EmployeePersonSummaryCounter,
  EmployeesPersonsSummary,
} from '@modules/employees/types/EmployeesPersons/employeesPersons'
import {
  CreateEmployeeByDocumentsRequest,
  CreateEmployeesPersonsRequest,
  FindEmployeePersonByIdRequest,
  FindEmployeePersonSummaryPaginatedRequest,
  UpdateEmployeesPersonsRequest,
  UploadEmployeePersonAvatarRequest,
} from '@modules/employees/types/EmployeesPersons/requests'

export class EmployeesPersonsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesPersonsRequest): Promise<EmployeePerson> {
    const response = await this.instance.post('/companies/employees', data)

    return response.data
  }

  async createByDocuments(data: CreateEmployeeByDocumentsRequest): Promise<EmployeePerson> {
    const formData = new FormData()

    if (data.armyCertificate) formData.append('armyCertificate', data.armyCertificate)
    if (data.birthCertificate) formData.append('birthCertificate', data.birthCertificate)
    if (data.driverLicense) formData.append('driverLicense', data.driverLicense)
    if (data.identification) formData.append('identification', data.identification)
    if (data.marriageCertificate) formData.append('marriageCertificate', data.marriageCertificate)
    if (data.voterCard) formData.append('voterCard', data.voterCard)
    if (data.workCard) formData.append('workCard', data.workCard)

    const response = await this.instance.post('/companies/employees/from-documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }

  async findOneById({ id }: FindEmployeePersonByIdRequest): Promise<EmployeePersonFull> {
    const response = await this.instance.get(`/companies/employees/${id}`)

    return response.data
  }

  async getPaginated(params: FindEmployeePersonSummaryPaginatedRequest): Promise<PaginateDTO<EmployeesPersonsSummary>> {
    const response = await this.instance.get('/companies/employees', { params })

    return response.data
  }

  async getSummaryCounter(): Promise<EmployeePersonSummaryCounter> {
    const response = await this.instance.get('/companies/employees/counter')

    return response.data
  }

  async update({ id, ...body }: UpdateEmployeesPersonsRequest): Promise<EmployeePerson> {
    const response = await this.instance.put(`/companies/employees/${id}`, body)

    return response.data
  }

  async uploadAvatar({ id, file }: UploadEmployeePersonAvatarRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('avatar', file)

    const response = await this.instance.put(`/companies/employees/${id}/avatar`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesPersonsService = (instance: AxiosInstance) => new EmployeesPersonsService(instance)
